import { render, staticRenderFns } from "./MessageCell.vue?vue&type=template&id=53189848&scoped=true&"
import script from "./MessageCell.vue?vue&type=script&lang=js&"
export * from "./MessageCell.vue?vue&type=script&lang=js&"
import style0 from "./MessageCell.vue?vue&type=style&index=0&id=53189848&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53189848",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/bikrampahi/Projects/upwork/5 Brian/sndle.io/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
installComponents(component, {VImg,VLayout,VProgressCircular})
